import * as React from 'react';
import styled from 'styled-components';

interface IParagraph {
  className?: string;
  center?: boolean;
  fontSize?: string;
  style?: any;
  children: any;
}

interface IProps extends React.HTMLAttributes<HTMLParagraphElement> {
  center?: boolean;
  fontsize?: string;
}

export const Paragraph: React.FC<IParagraph> = (props) => {
  return (
    <StyledParagraph
      center={props.center}
      fontsize={props.fontSize}
      className={props.className}
      style={props.style}
    >
      {props.children}
    </StyledParagraph>
  );
};

const StyledParagraph = styled.p<IProps>`
  ${(props) => (props.center ? 'text-align: center;' : '')}
  ${(props) => (props.fontsize ? `font-size: ${props.fontsize};` : '')}
  &.form-consent-text {
    font-size: 0.875rem;
  }
`;
